/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
import React from 'react'
import { connect } from 'react-redux'

import * as actionCreators from '../../../../../../src/store/actions'
import { injectComponent, mapStateToProps } from '../../../../../../src/utils'

export class MandatoryProfilePopupFieldsComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = () => {}
  }

  componentDidMount = async () => {
    this.checkMandatoryFields()
  }

  // componentDidUpdate = async prevProps => {
  //   const { session: prevSession } = prevProps
  //   const { session_data: prevSession_data } = prevSession
  //   const { mandatory_profile_fields: prev_mandatory_profile_fields } =
  //     prevSession_data
  //   const { session } = this.props
  //   const { session_data } = session
  //   const { mandatory_profile_fields } = session_data

  //   const { incomplete: prevIncomplete } = prev_mandatory_profile_fields
  //   const { incomplete } = mandatory_profile_fields
  //   if (incomplete !== prevIncomplete) {
  //     this.checkMandatoryFields()
  //   }
  // }

  componentDidUpdate = async prevProps => {
    // Estrazione degli oggetti con controllo per undefined
    const prevSession = prevProps.session || {};
    const prevSession_data = prevSession.session_data || {};
    const prev_mandatory_profile_fields = prevSession_data.mandatory_profile_fields || {};
  
    const session = this.props.session || {};
    const session_data = session.session_data || {};
    const mandatory_profile_fields = session_data.mandatory_profile_fields || {};
  
    // Controllo per undefined prima di accedere a 'incomplete'
    const prevIncomplete = prev_mandatory_profile_fields.incomplete;
    const incomplete = mandatory_profile_fields.incomplete;
  
    // Se 'incomplete' esiste ed è diverso da quello precedente, esegui il controllo
    if (incomplete !== undefined && incomplete !== prevIncomplete) {
      this.checkMandatoryFields();
    }
  }
  
  checkMandatoryFields = () => {
    const { session } = this.props;
    if (!session) {
      console.warn('Session is undefined.');
      return;
    }
  
    const { session_data } = session;
    if (!session_data) {
      console.warn('Session data is undefined.');
      return;
    }
  
    const { mandatory_profile_fields } = session_data;
    if (!mandatory_profile_fields) {
      console.warn('Mandatory profile fields are undefined.');
      return;
    }
  
    const { incomplete } = mandatory_profile_fields;
    if (incomplete) {
      const comp_id = `mandatory_fields_popup_componente_id`;
      const component_definition = {
        specialized: true,
        path: 'my_profile_group/mandatory_profile_popup_fields/mandatory_popup_body',
        data: {
          sender: this,
        },
      };
      injectComponent(this, comp_id, component_definition);
    }
  };
  

  // checkMandatoryFields = () => {
  //   const { session } = this.props
  //   const { session_data } = session
  //   const { mandatory_profile_fields } = session_data

  //   const { incomplete } = mandatory_profile_fields

  //   if (incomplete) {
  //     const comp_id = `mandatory_fields_popup_componente_id`
  //     const component_definition = {
  //       specialized: true,
  //       path: 'my_profile_group/mandatory_profile_popup_fields/mandatory_popup_body',
  //       data: {
  //         sender: this,
  //       },
  //     }
  //     injectComponent(this, comp_id, component_definition)
  //   }
  // }

  render() {
    return <></>
  }
}

export default connect(
  mapStateToProps,
  actionCreators
)(MandatoryProfilePopupFieldsComponent)
